module.exports = __webpack_public_path__ + "img/level_four_hover.743bce33.png";